import React, { Component } from 'react';
import '../css/ksp-list.less';

const KspList = ({ ksps, limit = 4, className }) => {
    return (
        <ul className={`ksps${ className ? ' ' + className : ''}`}>
            {ksps &&
                ksps.constructor === Array &&
                ksps.map((ksp, i) => {
                    let style;
                    if (i < limit) {
                        if (i === 0 && ksp && ksp.toLowerCase().indexOf('discontinued') > -1) {
                            style = { fontWeight: 'bold' };
                        }
                        return (
                            <li aria-label={ksp} tabIndex={0} style={style} key={i}>
                                {ksp}
                            </li>
                        );
                    }
                })}
        </ul>
    );
};

export default KspList;
